var _path, _path2, _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoNoBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.dev/svgjs",
    width: 1000,
    height: 623,
    viewBox: "0 0 1000 623",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.6060606060606233,0.2522267206477409)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 396 247",
    "data-background-color": "#ffffff",
    preserveAspectRatio: "xMidYMid meet",
    height: 623,
    width: 1000,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tight-bounds",
    transform: "matrix(1,0,0,1,0.2400000000000091,-0.09999999999999432)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 247.2",
    height: 247.2,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 247.2",
    height: 247.2,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,144.26797388724034,47.215199999999996)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 106.98405222551928 152.7696",
    height: 152.7696,
    width: 106.98405222551928,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 106.98405222551928 152.7696",
    height: 152.7696,
    width: 106.98405222551928,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 106.98405222551928 152.7696",
    height: 152.7696,
    width: 106.98405222551928,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 106.98405222551928 152.7696",
    height: 152.7696,
    width: 106.98405222551928,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "textblocktransform"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 106.98405222551928 152.7696",
    height: 152.7696,
    width: 106.98405222551928,
    id: "textblock",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 106.98405222551928 152.7696",
    height: 152.7696,
    width: 106.98405222551928,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 106.98405222551928,
    viewBox: "4 -33.70000076293945 23.600000381469727 33.70000076293945",
    height: 152.7696,
    "data-palette-color": "#35a3a1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6-33.7L27.6 0 24.5 0 24.5-15.75 7.1-15.75 7.1 0 4 0 4-33.7 7.1-33.7 7.1-18.6 24.5-18.6 24.5-33.7 27.6-33.7Z",
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "#35a3a1",
    className: "wordmark-text-0",
    "data-fill-palette-color": "primary",
    id: "text-0"
  })))))))))))))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.951 41.215L68.951 0 316.151 0 316.151 247.2 68.951 247.2 68.951 205.985 82.728 205.985 82.728 233.423 302.374 233.423 302.374 13.777 82.728 13.777 82.728 41.215Z",
    fill: "#35a3a1",
    stroke: "transparent",
    "data-fill-palette-color": "primary"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 395.52,
    height: 247.2,
    fill: "none",
    stroke: "none",
    visibility: "hidden"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoBackground);
export default __webpack_public_path__ + "static/media/logoNoBackground.54230223e722315a14bff2ddd403a86e.svg";
export { ForwardRef as ReactComponent };